import { BreakoutSwitch } from 'components/design-system/BreakoutSwitch'
import { BreakoutInfoTooltip } from 'components/design-system/BreakoutPrefabTooltips'
import { useFeatureFlags } from 'hooks/featureFlags'
import { useTranslationTyped } from 'i18n/i18n'
import { observer } from 'mobx-react-lite'

export const GradeAppealsSwitch = observer(function GradeAppealsSwitch({
  checked,
  disabled,
  showFinalGradeToParticipants,
  onChange,
}: {
  checked: boolean
  disabled: boolean
  showFinalGradeToParticipants: boolean
  onChange: (checked: boolean) => void
}) {
  const { studentGradeAppealsEnabled } = useFeatureFlags()
  const { tt } = useTranslationTyped()

  if (!studentGradeAppealsEnabled) return null

  return (
    <BreakoutSwitch
      checked={checked}
      disabled={disabled || !showFinalGradeToParticipants}
      onChange={(event) => onChange(event.target.checked)}
      className="w-full"
      accent
      labelPosition="left"
      labelClassName="!pl-0 w-full"
      label={
        <BreakoutInfoTooltip
          label={
            <div className="text-label-large text-on-surface">
              {tt.instructor_library.allow_grade_appeals()}
            </div>
          }
          content={tt.instructor_library.allow_grade_appeals_tooltip()}
        />
      }
      testId="grade-appeals-enabled"
    />
  )
})
